import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {  faFileAlt, faDownload } from '@fortawesome/pro-solid-svg-icons'
import { Dispatch, SubmitButton } from '../architecture/frontend/index'
import _ from 'lodash'

import { filter } from 'rxjs/operators'
import loading from '../../media/loading.svg'
import moment from 'moment'
import DatePicker from 'react-datepicker'
import "react-datepicker/dist/react-datepicker.css"

import React, {useCallback} from 'react'
import {useDropzone} from 'react-dropzone'

const Id = (props) => {
  const id = props._id
  const value = props._value
  const childClass = props._childClass
  return (
    <div className={'evonik-purple fw5 pointer ' + childClass }
      onClick={e => Dispatch.nextAction('shipment.select', id)}
      >
      #{value}
    </div>
  )
}

const Text = (props) => {
  const id = props._id
  const value = props._value
  const childClass = props._childClass
  const preText = props._preText
  const onClick = props._onClick ?? (() => null)
  return (
    <div className={'w-100 f6 fw5 ' + childClass} style={{}} onClick={e => onClick(e, { id })}>
      {preText}{value}
    </div>
  )
}

const Status = (props) => {
  const statuses = props.statuses
  const value = props._value
  const status = _.find(statuses, status => status.id === value)
  return (
    <div className='fw7 f7 evonik-light-green'>
      {status?.id + ': ' + status?.name}
    </div>
  )
}

const FileUpload = (props) => {
  const id = props._id
  const value = props._value
  return (
    <div className='tc flex justify-center'>

      {!_.isNil(value) ?
        <SubmitButton id={'save'} className='' 
        responseId='save'
        defaultChild={ props => (
            <FontAwesomeIcon className='f4 pointer ' onClick={e => Dispatch.nextAction('shipment.refereeDownload', id)} icon={faDownload} style={{color: '#7bb093'}}/>
        )}
        loadingChild={ props => (
            <div className='mh2 ' style={{width:20}}>
              <img src={loading} alt='loading'/>
            </div>
        )}
        errorChild={ props => (
          <div className='pl3 f7 fw4 red tr pointer'>Error</div>
        )}
        loadingStream={
          Dispatch.getAction('Request.removeRefereeUpload')
          }
        successStream={
          Dispatch.getAction('Response.removeRefereeUpload')
            .pipe(
              filter(e => _.isNil(e.errors) && ((!_.isNil(e.data.upsertShipment) || !_.isNil(e.data.upsertShipment) ))),
            )
          }
        errorStream={
          Dispatch.getAction('Response.removeRefereeUpload')
            .pipe(
              filter(e => !_.isNil(e.errors)),
            )}
      />
        :
        <SubmitButton id={'save'} className='' 
        responseId='save'
        defaultChild={ props => (
          <MyDropzone _id={id}/>
        )}
        loadingChild={ props => (
            <div className='mh2 ' style={{width:20}}>
              <img src={loading} alt='loading'/>
            </div>
        )}
        errorChild={ props => (
          <div className='pl3 f7 fw4 red tr pointer'>Error</div>
        )}
        loadingStream={
          Dispatch.getAction('Request.shipments.refereeUpload')
          }
        successStream={
          Dispatch.getAction('Response.shipments.refereeUpload')
            .pipe(
              filter(e => _.isNil(e.errors) && ((!_.isNil(e.data.uploadReferee) || !_.isNil(e.data.uploadReferee) ))),
            )
          }
        errorStream={
          Dispatch.getAction('Response.shipments.refereeUpload')
            .pipe(
              filter(e => !_.isNil(e.errors)),
            )}
      />  
            }
    </div>
  )
}

function MyDropzone(props) {
  const onDrop = useCallback(acceptedFiles => {
    Dispatch.nextAction('shipments.refereeUpload', {file: acceptedFiles[0], id: props._id})
  }, [])
  const {getRootProps, getInputProps, isDragActive} = useDropzone({onDrop, accept: {"text/*": [".txt", ".pdf"]}})
  return (
    <div className='pointer' {...getRootProps()}>
      <input {...getInputProps()} />
      {
          isDragActive ?
          <FontAwesomeIcon className='f4 ' icon={faFileAlt} style={{color: '#7bb093'}}/> :
            <FontAwesomeIcon className='f4 ' icon={faFileAlt} style={{color: '#7bb093'}}/>
      }
    </div>
  )
}

const RefereeControls = (props) => {
  const id = props._id
  const value = props._value
  const field = props._field
  return (
    <div className='w-100 fw7 f7 evonik-light-green flex justify-center'>
      {/* <input type="radio" name={id}
        value={id}
        checked={value} 
        onChange={e => Dispatch.nextAction('shipments.set', {id, field, value: e.currentTarget.value })} />

        <input type="radio" name={id}
        value={id}
        checked={!_.isNil(value) && !value} 
        onChange={e => Dispatch.nextAction('shipments.set', {id, field, value: e.currentTarget.value })} /> */}
        
         <div className={'ml2 pa2 ph3 br2 white f6 pointer ' + (!_.isNil(value) && value ? ' bg-evonik-light-green ' : ' bg-moon-gray ')} style={{}}
            onClick={e => Dispatch.nextAction('shipments.set', {id, field, value: true })}>
            To Referee
          </div>

          <div className={'ml2 pa2 ph3 bg-evonik-light-green br2 white f6 pointer ' + (!_.isNil(value) && !value ? ' bg-evonik-light-green ' : ' bg-moon-gray ')}  style={{}}
            onClick={e => Dispatch.nextAction('shipments.set', {id, field, value: false })}>
            Skip Referee
          </div>

        {/* <SubmitButton id={'toRef'} className='' 
          responseId='toRef'
          defaultChild={ props => (
            <div className={'ml2 pa2 ph3 bg-evonik-light-green br2 white f6 pointer '} style={{}}
              onClick={e => Dispatch.nextAction('shipments.toReferee', [{id, value: true}])}>
              Mark for Referee
            </div>
          )}
          loadingChild={ props => (
              <div className='mh3 ' style={{width:80, height: 30}}>
                <img className='w-100 h-100' src={loading} />
              </div>
          )}
          errorChild={ props => (
            <div className='pl3 f7 fw4 red tr pointer'>Error</div>
          )}
          loadingStream={
            Dispatch.getAction('Request.toReferee')
            .pipe(
                filter(e => e.variables?.refereeToSend)
              )
            }
          successStream={
            Dispatch.getAction('Response.toReferee')
              .pipe(
                filter(e => _.isNil(e.errors) && ((!_.isNil(e.data.upsertShipment) || !_.isNil(e.data.upsertShipment) ))),
              )
            }
          errorStream={
            Dispatch.getAction('Response.toReferee')
              .pipe(
                filter(e => !_.isNil(e.errors)),
              )}
        />
      <SubmitButton id={'toNotRef'} className='' 
        responseId='toNotRef'
        defaultChild={ props => (
          <div className={'ml2 pa2 ph3 bg-evonik-light-green br2 white f6 pointer ' } style={{}}
            onClick={e => Dispatch.nextAction('shipments.toReferee', [{id, value: false}])}>
            Skip Referee
          </div>
        )}
        loadingChild={ props => (
            <div className='mh3 ' style={{width:80, height: 30}}>
              <img className='w-100 h-100' src={loading} />
            </div>
        )}
        errorChild={ props => (
          <div className='pl3 f7 fw4 red tr pointer'>Error</div>
        )}
        loadingStream={
          Dispatch.getAction('Request.toReferee')
            .pipe(
              filter(e => !e.variables?.refereeToSend)
            )
          }
        successStream={
          Dispatch.getAction('Response.toReferee')
            .pipe(
              filter(e => _.isNil(e.errors) && ((!_.isNil(e.data.upsertShipment) || !_.isNil(e.data.upsertShipment) ))),
            )
          }
        errorStream={
          Dispatch.getAction('Response.toReferee')
            .pipe(
              filter(e => !_.isNil(e.errors)),
            )}
      /> */}
    </div>
  )
}

const Dollars = (props) => {
  const value = props._value
  return (
    <div className='w-100 fw5'>
      ${value}
    </div>
  )
}

// const ClaimableTestResult = (props) => {
//   const value = props._value
//   const claimableTable = {
//     refereeMoisture12Percent: 'refereeMoistureDollars',
//     refereeProtein12Percent: 'refereeProteinDollars',
//     refereeFiber12Percent: 'refereeFiberDollars',
//   }
//   const checkColor = claimTable 
//   return (
//     <div className='w-100 fw6 f6'>
//       <FontAwesomeIcon className='f4 pr1' icon={faCheck} style={{color: '#7bb093'}}/>{value}%
//     </div>
//   )
// }

const DeniedDate = (props) => {
  const value = props._value
  const childClass = props._childClass
  return (
    <>
      {value ? <div className={'pa1 br2 f6 fw6 bg-light-red white tc ' + childClass} style={{display: 'inline'}}>{moment(value).format('MM-DD-yyyy')}</div> : <div></div>}
    </>
  )
}

const DateDisplay = (props) => {
  const value = props._value
  const childClass = props._childClass
  return (
    <>
      {value ? <div className={'pa1 br2 f6 fw6 white tc bg-dark-blue ' + childClass } style={{display: 'inline'}}>{moment(value).format('MM-DD-yyyy')}</div> : <div></div>}
    </>
  )
}

const Checkbox = (props) => {
  const id = props._id
  const tableName = props._tableName
  //const checked = props._checked
  return (
    <div className=''>
      <input
        id={id}
        className={tableName}
        type="checkbox"
        //checked={checked}
        onChange={() => Dispatch.nextAction('table.checkbox.onchange', tableName)}
    />
    </div>
  )
}

// const FileUpload = (props) => {
//   return (
//         <div className='tc flex justify-center'>
//           <FontAwesomeIcon className='f4 ' icon={faFileAlt} style={{color: '#7bb093'}}/>
//         </div>
//   )
// }

const TextInput = (props) => {
  const id = props._id
  const value = props._value
  const object = props._field
  const childClass = props._childClass
  return (
      <input 
        className={'w-90 ph1 br2 bg-white f6 ba b--moon-gray ' + childClass }
        style={{ outline: 'none', borderStyle: 'solid' }} 
        type="text" 
        placeholder=''
        defaultValue={value}
        onChange={e => Dispatch.nextAction('__.buffer.setBuffer.shipments', {object, id, value: e.target.value})}
      />
  )
}


const DateInput = (props) => {
  const id = props._id
  const value = props._value && new Date(props._value)
  const object = props._field
  const childClass = props._childClass
  return (
    <div className='w4 ba b--moon-gray'>
      <DatePicker 
        className={'w-100 bn b--moon-gray input-reset ' + childClass} 
        selected={value} 

        onChange={e => Dispatch.nextAction('__.buffer.setBuffer.shipments', {object, id, value: moment(e).toISOString() })} />
    </div>
  )
}

const types = {
  id: Id,
  checkbox: Checkbox,
  text: Text,
  fileUpload: FileUpload,
  textInput: TextInput,
  deniedDate: DeniedDate,
  date: DateDisplay,
  dateInput: DateInput,
  status: Status,
  dollars: Dollars,
  refereeControls: RefereeControls,
 // claimableTestResult: ClaimableTestResult
}

export default types